import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => {

    return {
        termsContent: {
            background: 'white',
            width: '100%',
            maxWidth: 720,            
        },
        iframeContent: {
            width: '100%',
            height: '450px',
        },
        buttonContent: {            
            padding: theme.spacing(3),
            [theme.breakpoints.up("md")]: {
                padding: theme.spacing(0),
            }
        },
        buttonContinue: {
            width: '100%',
        }
    }
});

export default useStyles;